function init(section) {
	section.find(".add-to-watchlist-btn-small, .add-to-watchlist-btn").click(function (e){
		e.preventDefault();
		e.stopImmediatePropagation();

		openModal($(this).data("symbol"));
	})

	initModal();
};

function openModal(symbol) {
	console.log("ADD SYMBOL", symbol);

	$("#add-to-watchlists-modal").data("symbol", symbol);
	$('#add-to-watchlists-modal').modal('show');
}

function add(group_id,symbol,callback,error){
	ajax('watchlistAdd', { group_id:group_id,symbol: symbol }, function(res) {
		if(typeof callback !== "undefined"){
			callback(res);
		}
	},(e)=>{
		if(typeof error !== "undefined"){
			error(e);
		}
	});
};

function initModal() {
	const modal = $('#add-to-watchlists-modal');

	if (modal.data('watchlist-init')) {
		return;
	}

	modal.data('watchlist-init', true);

	modal.on({
		submit: async function(e) {
			e.preventDefault();
			var that = $(this),
				data = that.find('form').serializeJSON();

			console.log("automagically catch form submit");
			console.log(data);

			that.find(':submit').prop('disabled', true).text('Adding...');

			add(data.group_id,data.symbol,(res)=>{
				that.find(':submit').prop('disabled', false).text('Add')
				that.modal('hide')
				alert(data.symbol+" succesfully added to watchlist.")
			},(e)=>{
				that.find(':submit').prop('disabled', false).text('Add')
			});
		},
		'show.bs.modal': function(event){
			console.log("ADD TO WATCHLIST MODAL SHOW")
			//let button = $(event.relatedTarget) // Button that triggered the modal
			let symbol = $(this).data('symbol')

			console.log(symbol)
			let modal = $(this)

			modal.find('.modal-body .selected-symbol').html(symbol)

			modal.find('.modal-body input[name=symbol]').val(symbol)

		}
	});
}

const WatchlistButtons = { init, add, openModal, initModal }

export default WatchlistButtons;
